import { connect } from 'react-redux';
import { denormalize } from 'normalizr';
import { schema } from '../../../../../state/schema';

import SmsConversationList from '../components/SmsConversationList';
import {
  loadSmsConversations,
  clearSmsConversationLists,
} from '../../../../../state/modules/smsConversations/actions';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  const profileId = state.session.get('profileId');
  const partnershipId = storage.get(findStorageType(), 'partnershipId');
  const limit = 20;
  const order = ownProps.sortOrder || 'desc';
  const page = 1;

  const result = state.smsConversations.getIn([
    'pages',
    partnershipId,
    order,
    limit,
    page,
  ]);

  return {
    list: result
      ? result
          .map((x) => {
            const entity = state.entities.getIn(['smsConversations', x]);
            if (!entity) return null;

            return {
              key: x,
              ...denormalize(
                entity,
                schema.smsConversation,
                state.entities.toJS()
              ),
            };
          })
          .filter((item) => item !== null && item.id)
          .toArray()
      : [],
    isLoading: state.smsConversations.get('isLoading'),
    total: state.smsConversations.get('total'),
    limit,
    order,
    page,
    partnershipId,
    profileId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (partnershipId, page, limit, order, filter, cb) => {
      dispatch(
        loadSmsConversations(partnershipId, page, limit, order, filter, cb)
      );
    },
    clearLists: () => {
      dispatch(clearSmsConversationLists());
    },
  };
};

const SmsConversationListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsConversationList);

export default SmsConversationListContainer;
